
import { Component, Prop, Vue } from 'vue-property-decorator'
import { DeviceImportHistoryItem } from '@/data/models/DeviceImportHistoryItem'
import { timestampToDate } from '@/utils/DateFormatter'
import { formatDateToHoursAndMinuteString, formatDateTohDateMonthYearString } from '@/utils/DateHelper'

@Component({})
export default class ImportHistoryItem extends Vue {

  @Prop()
  importHistoryItem: DeviceImportHistoryItem

  @Prop() elevation!: number;

  @Prop({ default: '' })
  backgroundStyle!: string;

  get timestamp() {
    const date = timestampToDate(this.importHistoryItem.timestamp);

    if (!date) {
      return "";
    }

    return this.formatDateToTargetDate(date) +
      " " +
      this.formatDateToTargetTime(date);
  }

  formatDateToTargetTime(date: Date): string {
    return formatDateToHoursAndMinuteString(date);
  }

  formatDateToTargetDate(date: Date): string {
    return formatDateTohDateMonthYearString(date);
  }
}
